import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Footer Main */}
        <div className="footer-main">
          <div className="footer-section">
            <h5 className="footer-heading">{t('footer.links.services')}</h5>
            <ul className="footer-links">
              <li><a href="#vision">{t('header.vision')}</a></li>
              <li><a href="#skills">{t('header.skills')}</a></li>
              <li><a href="#offerings">{t('header.offerings')}</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h5 className="footer-heading">{t('footer.links.projects')}</h5>
            <ul className="footer-links">
              <li><a href="#projects">{t('projects.title')}</a></li>
              <li><a href="#employee">{t('employee.title')}</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h5 className="footer-heading">{t('footer.links.contact')}</h5>
            <ul className="footer-contact">
              <li><a href="mailto:antonicieslak1997@gmail.com">antonicieslak1997@gmail.com</a></li>
              <li><a href="tel:+48668510340">+48 668 510 340</a></li>
              <li>Poznań, Poland</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-brand">ApageDev</h4>
            <p className="footer-description">{t('footer.description')}</p>
          </div>
        </div>

        {/* Company Story Section */}
        <div className="footer-company-story">
          <p id="company-story-text">{t('cookie.companyStory')}</p>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="copyright">
            <p>{t('footer.text')}</p>
          </div>
          <div className="funding-link">
            <img src="/Stopkapaint.png" alt="EU Funding" className="funding-image" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;